export const logoNegative = [
  "608 134",
  `
  <title>MAAFOS</title>
  <span>MAAFOS</span>
`,
];
